export const STORE_PROJECTS = 'STORE_PROJECTS'
export const SET_CURRENT_PROJECT = 'SET_CURRENT_PROJECT'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js